@let currentItem = item();
<soft-ds-item
  variant="outline"
  size="sm"
  [interactive]="true"
  (activate)="activate.emit(currentItem)"
>
  <soft-ds-item-leading>
    <soft-icon [name]="currentItem.config.icon" size="sm" />
  </soft-ds-item-leading>
  <soft-ds-item-title>{{ currentItem.config.title() }}</soft-ds-item-title>
  <soft-ds-item-trailing
    class="sidebar-filter-trailing inline-flex items-center justify-center gap-2"
  >
    @if (isToggle()) {
      <!-- toggled via the row's activate; the switch itself is a passive indicator -->
      <soft-ds-switch class="page-filter-toggle"
                      size="sm"
                      [value]="toggleActive()"
                      [ariaLabel]="currentItem.config.title()"
                      data-testid="page-filter-toggle">
      </soft-ds-switch>
    }
    @else if (value(); as value) {
      <soft-filter-operator [operator]="value.operator">
      </soft-filter-operator>

      <soft-ds-chip
        variant="primary"
        size="sm"
        removable
        [removeLabel]="('#CORE_FILTER.LIST.CLEAR_FILTER' | translate) + ': ' + currentItem.config.title()"
        (remove)="clearFilter.emit(item())"
      >
        @switch (value.operator) {
          @case ('equals') {
            {{ value.value }}
          }
          @case ('notEquals') {
            {{ value.value }}
          }
          @case ('contains') {
            {{ value.value }}
          }
          @case ('notContains') {
            {{ value.value }}
          }
          @case ('like') {
            {{ value.value }}
          }
          @case ('startsWith') {
            {{ value.value }}
          }
          @case ('endsWith') {
            {{ value.value }}
          }
          @case ('greaterThan') {
            {{ value.value }}
          }
          @case ('lessThan') {
            {{ value.value }}
          }
          @case ('greaterThanOrEqual') {
            {{ value.value }}
          }
          @case ('lessThanOrEqual') {
            {{ value.value }}
          }
          @case ('in') {
            {{value.value.length}}
          }
          @case ('notIn') {
            !o {{value.value.length}}
          }
          @case ('between') {
            {{ value.value.from }} - {{ value.value.to }}
          }
          @default {
            {{ value }}
          }
        }
      </soft-ds-chip>
    }
  </soft-ds-item-trailing>
</soft-ds-item>
